import OutsideClickHandler from 'react-outside-click-handler';
import React from 'react';
import classNames from 'classnames';

import NumberInput from 'fantastic/components/common/NumberInput';
import utils from 'fantastic/lib/utils';

const { px } = utils;

const SizeSettings = (props) => {
  const size = props.size.value;

  const onChange = (value) => {
    const { onChange, size: { field } } = props;
    onChange(field, px(value));
  };

  return (
    <div className="btn-group">
      <NumberInput value={size.replace('px', '')} onChange={onChange} max={72} min={6} />
    </div>
  );
};

export default SizeSettings;
